/*@flow*/
import mkDropdownTemplate from './mkDropdownTemplate';
import * as loaders from 'queries/loaders';
import getFiltersQuery from 'lib/getFiltersQuery';
import * as I from 'immutable';

export default (mkDropdownTemplate({
  isMulti: true,
  isCreatable: true,
  loadValues: () => {
    const path = 'streetscapeAssets';
    const fs = getFiltersQuery();
    const filterMap = (fs.get(path, I.Map()): any);
    const filters: {} = filterMap.toJS();
    const o = {
      filters,
    };
    return loaders.issueSubcategoryLoader(o);
  },
}): any);
